<template>
    <b-modal
        id="rubric-show-description"
        :title="sectionIn.title"
        ok-only
        modal-class="apprentice-default-modal"
        :ok-title="$t('common.close')"
        size="md">
        <p>
            {{ sectionIn.description }}
        </p>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-description-show-modal-component',
    props: {
        sectionIn: [Array, Object],
    },
};
</script>

<style scoped></style>
